var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoData = function SvgIconNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 400 400"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f2ff",
    d: "M40 235.872a160 160 0 1 0 320 0 160 160 0 1 0-320 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6daff",
    d: "M201.056 206.652A120.61 120.61 0 0 0 80.444 327.264a122 122 0 0 0 1.072 16.136 160 160 0 0 0 239.412-2.756 122 122 0 0 0 .736-13.38 120.61 120.61 0 0 0-120.608-120.612"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M235.78 211.728h-17.932a16.564 16.564 0 0 0-16.608 13.284 15.976 15.976 0 0 0 15.752 18.648 12.8 12.8 0 0 1 12.36 16.06 13.104 13.104 0 0 1-12.876 9.48h-45.6a33.15 33.15 0 0 0-33.676 30.224 31.936 31.936 0 0 0 31.888 33.652h18.768a8.376 8.376 0 0 1 8.376 8.376v6.8a7.12 7.12 0 0 0 7.096 7.2 7.2 7.2 0 0 1 7.276 7.2v8.78a5.8 5.8 0 0 1-1.052 3.832 19.16 19.16 0 0 0-2.4 20.488 159.3 159.3 0 0 0 52.104-11.168 29.8 29.8 0 0 0 .856-6.764v-31.972a17.35 17.35 0 0 1 9.332-15.416 25.6 25.6 0 0 0 12.22-21.82 1.11 1.11 0 0 0-1.1-1.084h-12.48a6.4 6.4 0 0 1-6.4-6.4v-7.968a6.4 6.4 0 0 1 6.4-6.4h27.304a15.96 15.96 0 0 0 15-10.496 120.94 120.94 0 0 0-74.608-64.536"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M320.928 340.644a122 122 0 0 0 .736-13.38 120.612 120.612 0 1 0-241.2 0 122 122 0 0 0 1.072 16.136"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M259.244 384.544a29.8 29.8 0 0 0 .856-6.764v-31.932a17.35 17.35 0 0 1 9.332-15.416 25.6 25.6 0 0 0 12.22-21.82 1.11 1.11 0 0 0-1.1-1.084h-12.468a6.4 6.4 0 0 1-6.4-6.4v-7.968a6.4 6.4 0 0 1 6.4-6.4h27.304a15.96 15.96 0 0 0 15-10.496 120.94 120.94 0 0 0-74.608-64.536h-17.932a16.564 16.564 0 0 0-16.608 13.284 15.976 15.976 0 0 0 15.752 18.648 12.8 12.8 0 0 1 12.36 16.06 13.104 13.104 0 0 1-12.876 9.48h-45.6a33.15 33.15 0 0 0-33.676 30.224 31.936 31.936 0 0 0 31.888 33.652h18.768a8.376 8.376 0 0 1 8.376 8.376v6.8a7.12 7.12 0 0 0 7.096 7.2 7.2 7.2 0 0 1 7.276 7.2v8.78a5.8 5.8 0 0 1-1.052 3.832 19.16 19.16 0 0 0-2.4 20.488"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6daff",
    d: "M158.588 323a43.884 7.876 0 1 0 87.768 0 43.884 7.876 0 1 0-87.768 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M286.548 133.672a8.27 8.27 0 0 1-1.2 4.268l-3.848 6.46a44.09 44.09 0 0 1-37.62 21.28h-3.572a8.3 8.3 0 1 1 0-16.6h3.572a27.41 27.41 0 0 0 23.384-13.236l3.868-6.448a8.3 8.3 0 0 1 15.416 4.276M191.2 234.28a29.096 29.096 0 0 1-29.06-29.06v-10.764a7.536 7.536 0 0 1 15.068 0v10.764a14 14 0 0 0 14 14 7.536 7.536 0 1 1 0 15.068z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6daff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M203.412 147.404a43.13 43.13 0 0 0-43.128 43.132v4.312H177.2v31.6h52.144v-60.4l13.296.756a3.904 3.904 0 0 0 3.9-3.9v-11.596a3.904 3.904 0 0 0-3.9-3.904z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M203.412 161.632v73.512"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M193.416 148.572a43 43 0 0 0-9.484 3.476v74.4h9.484zm19.996-1.168h9.484v79.036h-9.484z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M186.976 165.788a4.744 4.744 0 0 0 7.012 2.128l9.424-6.284-12.4-12.4a43 43 0 0 0-9.236 4zm25.864 2.128-9.428-6.284 13.54-14.228H227.2l-7.352 18.4a4.744 4.744 0 0 1-7.008 2.112m-35.636 58.528h52.232v8.704h-52.232z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m177.204 235.148 9.396 87.692h33.18l9.568-87.692z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m177.204 235.148 9.396 87.692h33.18l9.568-87.692z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M203.192 254.152v68.688"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6daff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M203.276 322.884a14.22 14.22 0 0 0-14.22-14.22h-2.372a14.21 14.21 0 0 0-12.316 7.112 4.732 4.732 0 0 0 4.104 7.108zm0 0a14.22 14.22 0 0 1 14.22-14.22h2.368a14.22 14.22 0 0 1 12.32 7.112 4.732 4.732 0 0 1-4.108 7.108zM181.6 276.18h43.272l4.476-41.032h-52.144z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M216.928 147.404a4 4 0 0 1-4-4V128.82h-18.024v16.28a4 4 0 0 1-2.94 3.852l-.948.272 12.4 12.4 13.54-14.228z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M236.584 115.448a5.84 5.84 0 0 0-4.74-5.684v-3.792a28.432 28.432 0 1 0-56.864 0v3.792a5.804 5.804 0 0 0 .596 11.488 28.436 28.436 0 0 0 55.672 0 5.864 5.864 0 0 0 5.336-5.804"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6daff",
    d: "M184.456 119.004a3.556 3.556 0 1 0 7.112 0 3.556 3.556 0 1 0-7.112 0m30.804 0a3.556 3.556 0 1 0 7.112 0 3.556 3.556 0 1 0-7.112 0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M210.52 130.596a11.836 11.836 0 0 0-14.216 0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#4550e5",
    d: "M189.196 109.524a3.556 3.556 0 1 0 7.112 0 3.556 3.556 0 1 0-7.112 0m21.324 0a3.556 3.556 0 1 0 7.112 0 3.556 3.556 0 1 0-7.112 0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6daff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M191.564 60.952a11.848 11.848 0 1 0 23.696 0 11.848 11.848 0 1 0-23.696 0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6daff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M236.536 101.804a33.172 33.172 0 0 0-66.296 1.796v28.436a23.7 23.7 0 0 0 5.264 14.892 2.372 2.372 0 0 0 4.216-1.492V122a19.58 19.58 0 0 1 7.48-15.476 62.2 62.2 0 0 0 11.94-11.688 4.8 4.8 0 0 1 5.848-1.652c10.48 4.58 15.744 12.492 20.58 17.572 1.648 1.736 2.8-.048 5.112-.048a5.42 5.42 0 0 1 5.892 5.332c-.016-1.796.048-12.64-.036-14.236"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m262.8 127.232-15.464 2.376a4 4 0 0 1-4.56-3.344l-.276-1.804a4 4 0 0 1 3.344-4.56l15.464-2.376z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6daff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M260.56 112.668c-2.684.4-4.188 5.096-3.364 10.456s3.664 9.376 6.348 8.964l34-5.224-2.984-19.416z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M293.572 102.628c-2.56.4-3.632 7.232-2.4 15.272s4.312 14.248 6.872 13.852l46.356-7.12-4.476-29.128z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6daff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M334.866 111.186a7.368 14.736-8.737 1 0 14.565-2.238 7.368 14.736-8.737 1 0-14.565 2.238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4550e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M201.428 34.632c-4.7 0-9.672-13.548-9.672-20.832a9.676 9.676 0 0 1 19.348 0c0 7.284-4.976 20.832-9.676 20.832m-62.324-1.54a9.674 9.674 0 1 1 16.756-9.672c3.784 6.556 6.032 20.576 2.04 22.876-3.9 2.26-14.836-6.348-18.796-13.204M103.152 76.12a9.672 9.672 0 1 1 9.672-16.748c6.312 3.64 15.56 14.72 13.2 18.8-2.384 4.14-16.7 1.516-22.872-2.052M290.032 184c-6.312-3.64-15.56-14.724-13.2-18.8 2.4-4.148 16.708-1.524 22.88 2.04a9.677 9.677 0 1 1-9.68 16.76M93.536 131.364a9.672 9.672 0 1 1 0-19.344c7.284 0 20.832 4.972 20.832 9.672s-13.548 9.672-20.832 9.672m6.064 49.112a9.67 9.67 0 0 1 3.54-13.2c6.104-3.524 20.484-6.196 22.884-2.04 2.348 4.068-6.9 15.152-13.2 18.8a9.676 9.676 0 0 1-13.224-3.56M276.824 78.164c-2.352-4.072 6.896-15.152 13.2-18.8a9.672 9.672 0 1 1 9.672 16.748c-6.096 3.532-20.472 6.208-22.872 2.052M244.96 46.296c-4-2.308-1.732-16.348 2.036-22.876a9.674 9.674 0 1 1 16.756 9.672c-4.016 6.96-14.932 15.452-18.792 13.204"
  })));
};
export default SvgIconNoData;